import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getRememberedEmail } from '../../utils/remembered-email';
import { ForgotPasswordView, type ForgotPasswordState } from './ForgotPasswordView';

export default function ForgotPassword() {
  const location = useLocation();
  const prefillEmail =
    (location.state as { email?: string } | null)?.email ??
    getRememberedEmail();
  const [email, setEmail] = useState(prefillEmail);
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState<ForgotPasswordState>('form');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // In a real implementation, this would call the Cognito forgot password API.
      // For now, we'll simulate success.
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setState('success');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to send reset email');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ForgotPasswordView
      state={state}
      email={email}
      error={error}
      isLoading={isLoading}
      onEmailChange={setEmail}
      onSubmit={handleSubmit}
    />
  );
}
